import {
  HeroSection,
  FeaturesSection,
  TestimonialsSection,
  FAQSection,
} from "@/components/landing";

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <FeaturesSection />
      <TestimonialsSection />
      {/* <FAQSection /> */}
    </main>
  );
}
